import React, { useState, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import "./i18n/config";
import i18next from "i18next";
import { Row, Col } from "react-bootstrap";
import dayjs from "dayjs";
import { hours } from "./data/hours";
import CustomSelect from "./CustomSelect";
import { useRef } from "react";

function GiftReceiverFormComponent({ setValue, register, handleSubmit, errors, sendNow, setSendNow, ...props }) {
  const [lang, setLang] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const giftTextAreaMaxLength = t("giftTextAreaMaxLength");
  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };
  const [availableHours, setAvailableHours] = useState(hours)
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const dropdownButtonRef = useRef(null)

  //show only future hours if selected date is today.
  useEffect(() => {
    const today = dayjs().format('DD-MM-YYYY')
    if (today == dayjs(selectedDate).format('DD-MM-YYYY')) {
      let futureHours = [];
      hours.map(hour => {
        const time = hour.value.split(':');
        if ((dayjs().hour(time[0]).minute(time[1])).isAfter(dayjs())) {
          futureHours.push(hour);
        }
      })
      setAvailableHours(futureHours)
      setValue('gifteeTime', futureHours[0].value)
    } else {
      setValue('gifteeTime', hours[0].value)
      setAvailableHours(hours)
    }
  }, [selectedDate])

  //set today's date if user tries to select past date with keyboard.
  useEffect(() => {
    if (!isBefore(selectedDate)) {
      setSelectedDate(dayjs());
      setValue('gifteeDate', new Date(dayjs()).toISOString().split('T')[0])
      if (availableHours && availableHours.length) {
        setTimeout(() => {
          setValue('gifteeTime', availableHours[0].value);
        })
      }
    }
  }, [selectedDate])

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");
  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);


  const clearText = (id) => {
    document.getElementById(id).value = "";
    var countfield = document.getElementById("counter");
    countfield.innerHTML = "0/" + giftTextAreaMaxLength;
  };

  const isBefore = (date) => {
    if (!date) {
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date >= today;
  };

  const textCounter = (field, field2, maxlimit) => {
    var countfield = document.getElementById(field2);
    var textarea = document.getElementById(field);
    if (textarea.value.length > maxlimit) {
      textarea.value = textarea.value.substring(0, maxlimit);
      return false;
    }
    else {
      countfield.innerHTML = textarea.value.length + "/" + maxlimit;
    }
  }


  return (
    <>
      <h3 aria-label={t("sendGiftTo")} className="gift-to"> {t("sendGiftTo")}</h3>
      <form >
        <div className="receiver-form-wrap">
          <Row className="top-inputs">
            <Col sm={12} md={6}>
              <label htmlFor="GiftfullNameInput"> {t("GiftReceiverFullName")}</label>
              <input type="text" name="GiftfullNameInput" id="GiftfullNameInput"  {...register('GiftfullNameInput', { required: t("Required"), pattern: { value: new RegExp(t("FullNameRegex")), message: t("FullNameRegexMsg") } })} />
              <span role="alert" className="error">{errors.GiftfullNameInput?.message}</span>
            </Col>

            <Col sm={12} md={6}>
              <label htmlFor="GiftSenderfullNameInput"> {t("GiftSenderfullNameInput")}</label>
              <input type="text" name="GiftSenderfullNameInput" id="GiftSenderfullNameInput"  {...register('GiftSenderfullNameInput', { required: t("Required"), pattern: { value: new RegExp(t("FullNameRegex")), message: t("FullNameRegexMsg") } })} />
              <span role="alert" className="error">{errors.GiftSenderfullNameInput?.message}</span>
            </Col>
          </Row>

          <h3 aria-label={t("whenToSend")} className="gift-to">{t("whenToSend")}</h3>
          <Row className="top-inputs">
            <Col sm={4} md={4} className="d-flex radio-padding">
              <div className="d-flex ms-4 align-items-center">
                <input
                  className="ms-2"
                  defaultChecked
                  name="when-radio"
                  type='radio'
                  id='now'
                  onClick={() => setSendNow(true)}
                />
                <label className="mt-0" htmlFor="now">{t('now')}</label>
              </div>
              <div className="d-flex ms-4 align-items-center">
                <input
                  className="ms-2"
                  name="when-radio"
                  type='radio'
                  id='later'
                  onClick={() => setSendNow(false)}
                />
                <label className="nowrap mt-0" htmlFor="later">{t('later')}</label>
              </div>
            </Col>
            {
              !sendNow &&
              <>
                <Col sm={4} md={4}>
                  <label htmlFor="date">{t('date')}</label>
                  <div className="time-input-holder">
                  <svg className="calendar-icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="800px" height="800px" viewBox="0 0 610.398 610.398" xmlSpace="preserve">
                    <g>
                      <g>
                        <path d="M159.567,0h-15.329c-1.956,0-3.811,0.411-5.608,0.995c-8.979,2.912-15.616,12.498-15.616,23.997v10.552v27.009v14.052    c0,2.611,0.435,5.078,1.066,7.44c2.702,10.146,10.653,17.552,20.158,17.552h15.329c11.724,0,21.224-11.188,21.224-24.992V62.553    V35.544V24.992C180.791,11.188,171.291,0,159.567,0z" />
                        <path d="M461.288,0h-15.329c-11.724,0-21.224,11.188-21.224,24.992v10.552v27.009v14.052c0,13.804,9.5,24.992,21.224,24.992    h15.329c11.724,0,21.224-11.188,21.224-24.992V62.553V35.544V24.992C482.507,11.188,473.007,0,461.288,0z" />
                        <path d="M539.586,62.553h-37.954v14.052c0,24.327-18.102,44.117-40.349,44.117h-15.329c-22.247,0-40.349-19.79-40.349-44.117    V62.553H199.916v14.052c0,24.327-18.102,44.117-40.349,44.117h-15.329c-22.248,0-40.349-19.79-40.349-44.117V62.553H70.818    c-21.066,0-38.15,16.017-38.15,35.764v476.318c0,19.784,17.083,35.764,38.15,35.764h468.763c21.085,0,38.149-15.984,38.149-35.764    V98.322C577.735,78.575,560.671,62.553,539.586,62.553z M527.757,557.9l-446.502-0.172V173.717h446.502V557.9z" />
                        <path d="M353.017,266.258h117.428c10.193,0,18.437-10.179,18.437-22.759s-8.248-22.759-18.437-22.759H353.017    c-10.193,0-18.437,10.179-18.437,22.759C334.58,256.074,342.823,266.258,353.017,266.258z" />
                        <path d="M353.017,348.467h117.428c10.193,0,18.437-10.179,18.437-22.759c0-12.579-8.248-22.758-18.437-22.758H353.017    c-10.193,0-18.437,10.179-18.437,22.758C334.58,338.288,342.823,348.467,353.017,348.467z" />
                        <path d="M353.017,430.676h117.428c10.193,0,18.437-10.18,18.437-22.759s-8.248-22.759-18.437-22.759H353.017    c-10.193,0-18.437,10.18-18.437,22.759S342.823,430.676,353.017,430.676z" />
                        <path d="M353.017,512.89h117.428c10.193,0,18.437-10.18,18.437-22.759c0-12.58-8.248-22.759-18.437-22.759H353.017    c-10.193,0-18.437,10.179-18.437,22.759C334.58,502.71,342.823,512.89,353.017,512.89z" />
                        <path d="M145.032,266.258H262.46c10.193,0,18.436-10.179,18.436-22.759s-8.248-22.759-18.436-22.759H145.032    c-10.194,0-18.437,10.179-18.437,22.759C126.596,256.074,134.838,266.258,145.032,266.258z" />
                        <path d="M145.032,348.467H262.46c10.193,0,18.436-10.179,18.436-22.759c0-12.579-8.248-22.758-18.436-22.758H145.032    c-10.194,0-18.437,10.179-18.437,22.758C126.596,338.288,134.838,348.467,145.032,348.467z" />
                        <path d="M145.032,430.676H262.46c10.193,0,18.436-10.18,18.436-22.759s-8.248-22.759-18.436-22.759H145.032    c-10.194,0-18.437,10.18-18.437,22.759S134.838,430.676,145.032,430.676z" />
                        <path d="M145.032,512.89H262.46c10.193,0,18.436-10.18,18.436-22.759c0-12.58-8.248-22.759-18.436-22.759H145.032    c-10.194,0-18.437,10.179-18.437,22.759C126.596,502.71,134.838,512.89,145.032,512.89z" />
                      </g>
                    </g>
                  </svg>
                  <input
                    min={new Date().toISOString().split('T')[0]}
                    defaultValue={new Date(dayjs()).toISOString().split('T')[0]}
                    onInput={(e) => setSelectedDate(dayjs(e.target.value))}
                    type="date"
                    id="date"
                    {...register('gifteeDate', { required: t("Required") })}
                  />
                  </div>
                  
                  <span role="alert" className="error">{errors.gifteeDate?.message}</span>
                </Col>
                <Col sm={4} md={4}>
                  <label htmlFor="time">{t('hour')}</label>
                  <div ref={dropdownButtonRef} className="time-input-holder">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" width="64px" height="64px"><path d="M 64 13.5 C 36.2 13.5 13.5 36.2 13.5 64 C 13.5 91.8 36.2 114.5 64 114.5 C 91.8 114.5 114.5 91.8 114.5 64 C 114.5 36.2 91.8 13.5 64 13.5 z M 64 19.5 C 88.5 19.5 108.5 39.5 108.5 64 C 108.5 88.5 88.5 108.5 64 108.5 C 39.5 108.5 19.5 88.5 19.5 64 C 19.5 39.5 39.5 19.5 64 19.5 z M 64 31 C 62.3 31 61 32.3 61 34 L 61 58.800781 C 59.2 59.800781 58 61.8 58 64 C 58 67.3 60.7 70 64 70 C 66.2 70 68.199219 68.8 69.199219 67 L 84 67 C 85.7 67 87 65.7 87 64 C 87 62.3 85.7 61 84 61 L 69.199219 61 C 68.699219 60.1 67.9 59.300781 67 58.800781 L 67 34 C 67 32.3 65.7 31 64 31 z" /></svg>
                    <CustomSelect
                      register={register}
                      options={availableHours}
                      setValue={setValue}
                      dropdownButtonRef={dropdownButtonRef}
                      />
                  </div>
                  <span role="alert" className="error">{errors.gifteeTime?.message}</span>
                </Col>
              </>
            }
          </Row>
          <Row className="botom-inputs">
            <Col sm={12} md={6}>
              <h3 aria-label={t('HowToSend')} className="gift-to">{t('HowToSend')}</h3>
              <Row className="top-inputs">
                <Col sm={12} md={12}>

                  <Row>
                    <Col sm={12} md={4}> <label htmlFor="GifteePhoneInput"> {t("GiftReceiverPhone")}</label></Col>
                    <Col sm={12} md={8}>
                      <input
                        id="GifteePhoneInput"
                        name="GifteePhoneInput"
                        type="tel"
                        {...register("GifteePhoneInput", {

                          pattern: {
                            value: new RegExp(t("PhoneRegex")),
                            message: t("PhoneRegexMsg"),
                          },
                        })}

                      />
                      <span role="alert" id="errGiftPhoneInput" className="error">{errors.GifteePhoneInput?.message}</span>

                    </Col>
                  </Row>


                </Col>
                <Col sm={12} md={12}>
                  <Row className="mail-row">
                    <Col sm={12} md={4}><label htmlFor="GiftEmailInput"> {t("Email")}</label></Col>
                    <Col sm={12} md={8}> <input id="GiftEmailInput" type="email" name="GiftEmailInput"  {...register('GiftEmailInput', { pattern: { value: new RegExp(t("EmailRegex")), message: t("EmailRegexMsg") } })} />
                      <span role="alert" id="GiftEmailInput" className="error">{errors.GiftEmailInput?.message}</span></Col>
                  </Row>


                </Col>
              </Row>

            </Col>
            <Col sm={12} md={6}>
              <Row>
                <Col sm={12} md={12}><label htmlFor="GiftFreeTextInput">{(t("GiftReceiverFreeText") + " " + t("GiftReceiverFreeTextRemarks"))}</label></Col>
              </Row>

              <textarea className="text-area" id="GiftFreeTextInput" onKeyUp={e => textCounter('GiftFreeTextInput', 'counter', giftTextAreaMaxLength)} name="GiftFreeTextInput" {...register("GiftFreeTextInput", { maxLength: giftTextAreaMaxLength })} rows="4" ></textarea>
              <div>
                <Col sm={12} md={12}><div className="words-counter">
                  <span role="button" aria-label={t("delete")} className="delete" onClick={e => clearText('GiftFreeTextInput')}>{t("delete")}</span>
                  <span id={"counter"}>0/{giftTextAreaMaxLength}</span>

                </div>  </Col>
              </div>
            </Col>
          </Row>
        </div>
      </form>
    </>
  );
}

export default GiftReceiverFormComponent;
